import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { headerStyles } from "@dana/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationHeader";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

headerStyles.container = mergeToNew(headerStyles.container, {
    css: css`
        padding: 24px;
        background: ${themeBackgrounds.white};
    `,
});

headerStyles.titleText = mergeToNew(headerStyles.titleText, {
    css: css`
        margin-bottom: 16px;
    `,
});

headerStyles.orderNumberText = mergeToNew(headerStyles.orderNumberText, {
    css: css`
        margin-bottom: 16px;
    `,
});

headerStyles.orderInfoGridItem = mergeToNew(headerStyles.orderInfoGridItem, {
    width: [12, 8, 8, 8, 8],
});

headerStyles.buttonsGridItem = mergeToNew(headerStyles.buttonsGridItem, {
    width: [12, 4, 4, 4, 4],
    css: css`
        gap: 16px;

        @media only screen and (max-width: 992px) {
            flex-direction: column;
            justify-content: flex-start;
        }
    `,
});
